/*

 By Emotion
 Partly using https://raw.githubusercontent.com/SimonWaldherr/micromarkdown.js/master/micromarkdown.js

 */

document.addEventListener('DOMContentLoaded', () => {
  const imagesWithFloornumbers = document.querySelectorAll('img[title]');
  if (imagesWithFloornumbers) {
    for (let i = 0; i < imagesWithFloornumbers.length; i++) {
      const title = imagesWithFloornumbers[i].getAttribute('title');
      // eslint-disable-next-line no-useless-escape
      if (/!?\[([^\]<>]+)\]\(([^ \)<>]+)( "[^\(\)\"]+")?\)/g.exec(title)) {

        const parent = imagesWithFloornumbers[i].parentElement;
        const bodyClasses = document.querySelector('body').classList;

        // Exclude swiper slides & searchresults
        if (!(parent.classList.contains('exclude-floornumbers') ||
          bodyClasses.contains('search-results'))) {

          const wrapper = document.createElement('div');
          wrapper.classList.add('position-relative');
          parent.insertBefore(wrapper, imagesWithFloornumbers[i]);
          wrapper.appendChild(imagesWithFloornumbers[i]);

          // eslint-disable-next-line no-useless-escape
          const svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.3925 11.3137C13.3926 11.115 13.4716 10.9244 13.6121 10.7839C13.7527 10.6433 13.9433 10.5643 14.142 10.5642L22.6273 10.5642C22.826 10.5643 23.0166 10.6433 23.1571 10.7839C23.2977 10.9244 23.3767 11.115 23.3768 11.3137V19.799C23.3804 19.8997 23.3636 20 23.3275 20.094C23.2915 20.1881 23.2368 20.2739 23.1669 20.3464C23.0969 20.4188 23.0131 20.4764 22.9204 20.5158C22.8277 20.5552 22.728 20.5755 22.6273 20.5755C22.5266 20.5755 22.4269 20.5552 22.3342 20.5158C22.2415 20.4764 22.1576 20.4188 22.0877 20.3464C22.0177 20.2739 21.9631 20.1881 21.927 20.094C21.891 20 21.8742 19.8997 21.8778 19.799L21.8778 13.1239L11.8439 23.1578C11.7033 23.2984 11.5125 23.3774 11.3136 23.3774C11.1147 23.3774 10.9239 23.2984 10.7832 23.1578C10.6426 23.0171 10.5636 22.8263 10.5636 22.6274C10.5636 22.4285 10.6426 22.2378 10.7832 22.0971L20.8171 12.0633L14.142 12.0633C13.9433 12.0631 13.7527 11.9841 13.6121 11.8436C13.4716 11.703 13.3926 11.5125 13.3925 11.3137Z" fill="white"/>
          </svg>`;
          const stra = /!?\[([^\]<>]+)\]\(([^ )<>]+)( "[^()"]+")?\)/g.exec(title);
          const link = document.createElement('a');
          const span = document.createElement('span');
          const spanlink = document.createElement('span');
          const node = document.createTextNode(stra[1]);
          link.setAttribute('href', stra[2]);
          link.setAttribute('title', stra[1]);
          link.setAttribute('ga-on', 'click');
          link.setAttribute('ga-event-category', 'Floornumber');
          link.setAttribute('ga-event-action', 'link');
          link.setAttribute('ga-event-label', stra[1]);
          link.classList.add('stretched-link');
          span.classList.add('c-floornumber');
          spanlink.classList.add('sf_button_only_icon', 'bg-cherry');
          spanlink.innerHTML = svgIcon;
          span.appendChild(node);
          span.appendChild(spanlink);
          link.appendChild(span);
          wrapper.appendChild(link);
        }
      }
    }
  }

  if (!('ontouchstart' in document.documentElement)) {
    document.documentElement.className += ' no-touch';
  }
});




// WEBPACK FOOTER //
// ./src/scripts/modules/floornumbers.js